// Global org settings (nonprofit credentials + public emails), fetched once and cached.
import { useEffect, useState } from "react";
import { getOrgSettings } from "@/lib/api";

const DEFAULTS = {
  org_name: "Big Little Village",
  org_tagline: "Creative Internship Cohort",
  nonprofit_designation: "501(c)(3) Nonprofit Organization",
  ein: "",
  founding_location: "Houston, Texas",
  email_general: "hello@downinthevillage.org",
  email_partnerships: "partnerships@downinthevillage.org",
  email_cohort: "cohort@downinthevillage.org",
};

let cache = null;
let inflight = null;

export const useOrgSettings = () => {
  const [org, setOrg] = useState(cache || DEFAULTS);

  useEffect(() => {
    if (cache) return;
    inflight = inflight || getOrgSettings().then((d) => { cache = d; return d; }).catch(() => DEFAULTS);
    inflight.then((d) => setOrg(d));
  }, []);

  return org;
};

export const invalidateOrgSettings = () => { cache = null; inflight = null; };
